import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';

const RoleList = lazy(() => import('../modules/admin/roles/pages/role-list'));
const ManageRoles = lazy(
  () => import('../modules/admin/roles/pages/manage-roles')
);

const RolesRoutes = (
  <>
    <Route
      path="roles"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <RoleList />
        </Suspense>
      }
    />
    <Route
      path="roles/manage-roles"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ManageRoles />
        </Suspense>
      }
    >
      <Route
        path=":roleID"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <ManageRoles />
          </Suspense>
        }
      />
    </Route>
  </>
);

export default RolesRoutes;
